import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {AccountRoutingModule} from './account-routing.module';
import {AccountFormComponent} from './account-form/account-form.component';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {ConsentPage} from './consent/consent.page';
import {NgSelectModule} from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule.forChild(),
        AccountRoutingModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
    ],
  declarations: [
    AccountFormComponent,
    ConsentPage
  ]
})
export class AccountModule {
}
